import React from "react"
import {PictureMosaic} from "../../../picture_mosaic/picture_mosaic";

const Description = () => {

  const descriptions =  [
    {
      dataAttributeName: "data-logo-url",
      description: "Url of the image, to which the mosaic builds up to.",
      required: true,
    },
    {
      dataAttributeName: "data-grid-width",
      description: "Horizontal amount of tiles/cells.",
      required: true,
    },
    {
      dataAttributeName: "data-grid-height",
      description: "Vertical amount of tiles/cells.",
      required: true,
    },
    {
      dataAttributeName: "data-image-interval",
      description: "Interval in milliseconds, in which new tiles appear."
    },
    {
      dataAttributeName: "data-picture-mode",
      description: "Can be one of the following: media_files, tag_owner_images, stored_photos. Default is stored_photos. This determines as what images will be uploaded."
    },
    {
      dataAttributeName: "data-tile-color",
      description: "Css color, for tiles/cells the block the mosaic image initially."
    },
    {
      dataAttributeName: "data-seed",
      description: "Seed which determines the random order of the tiles/cells. Default is 71443."
    },
    {
      dataAttributeName: "data-min-background-threshold",
      description: "Minimum threshold value to which tiles will be applied to. Only applies for data-mosaic-mode='logo'. RGB value of a tile/cell is summed up and the average of that is calculated and compared against this value. (0-255)"
    },
    {
      dataAttributeName: "data-max-background-threshold",
      description: "Maximum threshold value to which tiles will be applied to. Only applies for data-mosaic-mode='logo'. RGB value of a tile/cell is summed up and the average of that is calculated and compared against this value. (0-255)"
    },
    {
      dataAttributeName: "data-mosaic-mode",
      description: "Can be one of the following: default, logo. Default is default. This determines how the tiles/cells are applied to the mosaic image. If set to logo, the tiles/cells will only be applied to the background of the mosaic image. If set to default, the tiles/cells will be applied to the whole mosaic image."
    },
    {
      dataAttributeName: "data-overlay-opacity",
      description: "Sets the opacity of the overlay image (data-logo-url). (0-1)"
    },
    {
      dataAttributeName: "data-canvas-opacity",
      description: "Sets the opacity of the canvas (Mosaic images). (0-1)"
    },
    {
      dataAttributeName: "data-overlay-blend-mode",
      description: "Set the blend mode of the overlay image (data-logo-url). Default is unset. Can be any valid mix-blend-mode."
    },
    {
      dataAttributeName: "data-image-identifier",
      description: "Only images with this identifier will be used. If not set, all images will be used."
    },
    {
      dataAttributeName: "data-only-approved-images",
      description: "Only approved images will be used. Only works with picture mode tag_owner_images. Default is false. Can be true or false."
    },
  ]

  return <div>
    <h2>
      Selfie Upload
    </h2>
    <p>Below you find a list with all the selfie upload attributes that can be set.</p>
    <ul>
      {descriptions.map(description => {
        return <li key={description.dataAttributeName}>
          <strong>{description.dataAttributeName}{description.required ? " (required)" : ""}</strong>:
          {" "}
          {description.description}
        </li>
      })}
    </ul>
  </div>
}

export const RenderedPictureMosaic = ({node}) => {

  const imageUrl = node.attribs["data-logo-url"]
  const gridWidth = parseInt(node.attribs["data-grid-width"])
  const gridHeight = parseInt(node.attribs["data-grid-height"])
  const imageInterval = parseInt(node.attribs["data-image-interval"] || 5000)
  const pictureMode = node.attribs["data-picture-mode"] || "stored_photos"
  const blockingTileColor = node.attribs["data-tile-color"]
  const seed = parseInt(node.attribs["data-seed"] || 71443)
  const minBackgroundThreshold = parseInt(node.attribs["data-min-background-threshold"] || 0)
  const maxBackgroundThreshold = parseInt(node.attribs["data-max-background-threshold"] || 255)
  const mosaicMode = node.attribs["data-mosaic-mode"] || "default"
  const overlayOpacity = parseFloat(node.attribs["data-overlay-opacity"] || 0.8)
  const canvasOpacity = parseFloat(node.attribs["data-canvas-opacity"] || 1)
  const overlayMixBlendMode = node.attribs["data-overlay-blend-mode"] || "unset"
  const imageIdentifier = node.attribs["data-image-identifier"]
  const onlyApprovedImages = node.attribs["data-only-approved-images"] === "true"

  if (!imageUrl) {
    return <div>
      <Description/>
    </div>
  }

  if (!gridWidth || isNaN(gridWidth) || gridWidth <= 0) {
    alert("data-grid-width must be set to a valid number and greater than 0")
  }

  if (!gridHeight || isNaN(gridHeight) || gridHeight <= 0) {
    alert("data-grid-height must be set to a valid number and greater than 0")
  }

  if (!imageInterval || isNaN(imageInterval) || imageInterval <= 0) {
    alert("data-image-interval must be set to a valid number and greater than 0")
  }

  if (!seed || isNaN(seed) || seed <= 0) {
    alert("data-seed must be set to a valid number and greater than 0")
  }

  if ((!minBackgroundThreshold && minBackgroundThreshold !== 0) || isNaN(minBackgroundThreshold) || minBackgroundThreshold > 255) {
    alert("data-min-background-threshold must be set to a valid number and less than 255")
  }

  if ((!maxBackgroundThreshold && maxBackgroundThreshold !== 0) || isNaN(maxBackgroundThreshold) || maxBackgroundThreshold > 255) {
    alert("data-max-background-threshold must be set to a valid number and less than 255")
  }

  if ((!overlayOpacity && overlayOpacity !== 0) || isNaN(overlayOpacity) || overlayOpacity < 0 || overlayOpacity > 1) {
    alert("data-overlay-opacity must be set to a valid number between 0 and 1")
  }

  if ((!canvasOpacity && canvasOpacity !== 0) || isNaN(canvasOpacity) || canvasOpacity < 0 || canvasOpacity > 1) {
    alert("data-overlay-opacity must be set to a valid number between 0 and 1")
  }

  if (!['media_files', 'tag_owner_images', 'stored_photos'].includes(pictureMode)) {
    alert("data-picture-mode must be set to one of the following: media_files, tag_owner_images, stored_photos")
  }

  if (!['default', 'logo'].includes(mosaicMode)) {
    alert("data-mosaic-mode must be set to one of the following: default, logo")
  }

  if ((node.attribs["data-only-approved-images"] && node.attribs["data-only-approved-images"] !== "true") || (onlyApprovedImages && pictureMode !== "tag_owner_images")) {
    alert("data-only-approved-images can only be set to true and only be used with picture mode tag_owner_images")
  }

  if (node.attribs["data-tile-color"] && !CSS.supports('color',blockingTileColor)) {
    alert("data-tile-color must be set to a valid color")
  }

  if (!CSS.supports('mix-blend-mode', overlayMixBlendMode)) {
    alert("data-overlay-blend-mode must be set to a valid mix-blend-mode")
  }

  return <PictureMosaic
    imageUrl={imageUrl}
    gridWidth={gridWidth}
    gridHeight={gridHeight}
    imageInterval={imageInterval}
    pictureMode={pictureMode}
    blockingTileColor={blockingTileColor}
    seed={seed}
    minBackgroundThreshold={minBackgroundThreshold}
    maxBackgroundThreshold={maxBackgroundThreshold}
    mosaicMode={mosaicMode}
    overlayOpacity={overlayOpacity}
    canvasOpacity={canvasOpacity}
    overlayMixBlendMode={overlayMixBlendMode}
    imageIdentifier={imageIdentifier}
    onlyApprovedImages={onlyApprovedImages}
  />
}